import { colorsObject } from "data/colors/colorPalettes"
import { colorPallet as c } from "data/colors/colorPalettes"

export const apiVersions = {
  V1: 'v1'
}

export const apiPaths = {
  ADMIN_DASHBOARD: 'admin.dashboard',
  ADMIN_USERS: 'admin.users',
  ADMIN_USERS_BALANCE: 'admin.users-balance',
  ADMIN_PERMISSIONS: 'admin.permission',
  ADMIN_CAMPAIGNS: 'admin.campaigns',
  ADMIN_COUNTRY: 'admin.country',
  ADMIN_TOPUPS: 'admin.topups',
  ADMIN_LOGIN_HISTORY: 'admin.login-history',
  ADMIN_PROFILE: 'admin.profile',
  ADMIN_GROUPS: 'admin.groups',
  ADMIN_STATS: 'admin.stats',
  ADMIN_FAST_LOGIN: 'admin.fast-login',
  ADMIN_UNAPPROVED_CREATIVES: 'admin.unapproved.creatives',
  ADMIN_UNAPPROVED_USERS: 'admin.unapproved.users',
  ADMIN_CAMPAIGNS_CREATIVES: 'admin.campaigns.creatives',
  ADMIN_CAMPAIGNS_AUDIENCE: 'admin.campaigns.audience',
  ADMIN_CAMPAIGNS_PRICING: 'admin.campaigns.pricing',
  ADMIN_CAMPAIGNS_LIMITS: 'admin.campaigns.limits',
  ADMIN_CAMPAIGNS_GROUPS: 'admin.campaigns.groups',
  ADMIN_CAMPAIGNS_BIDS: 'admin.campaigns.bids',
  ADMIN_BIDS: 'admin.bids',
  ADMIN_LOGS: 'admin.logs',
  ADMIN_RECOMMENDED_CPC: 'admin.recommended-cpc',
  ADMIN_OVERVIEW: 'admin.overview',
  ADMIN_CHANGELOG: 'admin.change-log',

  ADVERTISER_DASHBOARD: 'advertiser.dashboard',
  ADVERTISER_CAMPAIGNS: 'advertiser.campaigns',
  ADVERTISER_STATS: 'advertiser.stats',
  ADVERTISER_LOGIN_HISTORY: 'advertiser.login-history',
  ADVERTISER_TOPUPS: 'advertiser.topups',
  ADVERTISER_CHANGELOG: 'advertiser.change-log',

  AFFILIATE_CHANGELOG: 'affiliate.change-log',

  ADVERTISER_CAMPAIGNS_CREATIVES: 'advertiser.campaigns.creatives',
  ADVERTISER_CAMPAIGNS_AUDIENCE: 'advertiser.campaigns.audience',
  ADVERTISER_CAMPAIGNS_PRICING: 'advertiser.campaigns.pricing',
  ADVERTISER_CAMPAIGNS_LIMITS: 'advertiser.campaigns.limits',
  ADVERTISER_CAMPAIGNS_GROUPS: 'advertiser.campaigns.groups',
  ADVERTISER_CAMPAIGNS_BIDS: 'advertiser.campaigns.bids',
  SETTINGS: 'settings',

  NOTIFICATIONS: 'change_log_notifications'
}

export const apiActions = {
  LIST: 'list',
  GET: 'get',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  VALIDATE: 'validate',
  DUPLICATE: 'duplicate',
  SUM: 'sum',
  CHART: 'chart',
  BALANCE: 'balance',
  REPORT: 'report',
  APPROVED: 'approved',
  REJECT: 'reject',
  TOTAL: 'total',
  ARCHIVE: 'archive',
  SET_MANAGER: 'set-manager',
  QUEUE_EMAIL: 'queue-email',
  COPY: 'copy',
  COUNTRIES: 'countries',
  CHECK: 'check',
  SEEN: 'seen',
  COUPON: 'coupon'
}

export const boolean = {
  boolean: {
    label: 'Boolean true/false',
    data: {
      default: {
        label: 'No',
        value: 'false',
        theme: colorsObject().englishRed,
        booleanValue: 0,
      },
      true: {
        label: 'Yes',
        value: 'true',
        theme: colorsObject().forrestGreenCrayola,
        booleanValue: 1,
      },
      false: {
        label: 'No',
        value: 'false',
        theme: colorsObject().englishRed,
        booleanValue: 2,
      },
    }
  },
  booleanString: {
    label: 'Boolean "true"/"false"',
    data: {
      default: {
        label: 'No',
        value: 'false',
        theme: colorsObject().englishRed,
        booleanValue: 0,
      },
      true: {
        label: 'Yes',
        value: 'true',
        theme: colorsObject().forrestGreenCrayola,
        booleanValue: 1,
      },
      false: {
        label: 'No',
        value: 'false',
        theme: colorsObject().englishRed,
        booleanValue: 2,
      },
    }
  },
  booleanYesNo: {
    label: 'Boolean "Yes"/"No"',
    data: {
      default: {
        label: 'No',
        value: 'no',
        theme: colorsObject().englishRed,
        booleanValue: 0,
      },
      yes: {
        label: 'Yes',
        value: 'yes',
        theme: colorsObject().forrestGreenCrayola,
        booleanValue: 1,
      },
      no: {
        label: 'No',
        value: 'no',
        theme: colorsObject().englishRed,
        booleanValue: 2,
      },
    }
  },
  booleanNumber: {
    label: 'Boolean 1/0',
    data: {
      default: {
        label: 'No',
        value: 0,
        theme: colorsObject().englishRed,
        booleanValue: 0,
      },
      '1': {
        label: 'Yes',
        value: 1,
        theme: colorsObject().forrestGreenCrayola,
        booleanValue: 1,
      },
      '0': {
        label: 'No',
        value: 0,
        theme: colorsObject().englishRed,
        booleanValue: 2,
      },
    }
  }
}

export const common = {
  ...boolean,
  devices: {
    label: 'Devices',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      'desktop': {
        label: 'Desktop',
        value: 'desktop',
        theme: colorsObject().starCommandBlue,
      },
      'mobile': {
        label: 'Mobile',
        value: 'mobile',
        theme: colorsObject().rebeccaPurple,
      },
      'tablet': {
        label: 'Tablet',
        value: 'tablet',
        theme: colorsObject().ochre,
      },
      'unknown': {
        label: 'Unknown',
        value: 'unknown',
        theme: colorsObject().darkByzantium,
      }
    },
  },
  empty: {
    label: 'Empty',
    data: {},
  }
}

export const user = {
  usersStatus: {
    label: 'Users status',
    data: {
      default: {
        label: "Unknown",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Admin",
        value: 1,
        theme: colorsObject().amazon,
      },
      2: {
        label: "Account Manager",
        value: 2,
        theme: colorsObject().burntSienna,
      },
      3: {
        label: "Advertiser",
        value: 3,
        theme: colorsObject().rebeccaPurple,
      },
      4: {
        label: "Affiliate",
        value: 4,
        theme: colorsObject().starCommandBlue,
      },
      5: {
        label: "Support",
        value: 5,
        theme: colorsObject().amaranth,
      },
      6: {
        label: "Finance",
        value: 6,
        theme: colorsObject().flickrPink,
      },
      99: {
        label: "Banned",
        value: 99,
        theme: colorsObject().englishRed,
      },
    }
  },
  usersType: {
    label: 'Users type',
    data: {
      default: {
        label: "Unknown",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Internal",
        value: 1,
        theme: colorsObject().starCommandBlue,
      },
      2: {
        label: "External",
        value: 2,
        theme: colorsObject().royalPurple,
      },
    }
  },
}

export const domains = {
  domainsStatus: {
    label: 'Domains status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Active',
        value: 1,
        theme: colorsObject().forrestGreenCrayola,
      },
      2: {
        label: 'Inactive',
        value: 2,
        theme: colorsObject().englishRed,
      },
    }
  },
  domainsType: {
    label: 'Domains type',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey
      },
      1: {
        label: 'Tracking',
        value: 1,
        theme: colorsObject().fuzzyWuzzy
      }
    }
  },
  domainsTypeFull: {
    label: 'Domains type full',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey
      },
      1: {
        label: 'Tracking',
        value: 1,
        theme: colorsObject().fuzzyWuzzy
      },
      2: {
        label: 'Prelanding',
        value: 2,
        theme: colorsObject().bdazzledBlue
      },
      3: {
        label: 'Landing',
        value: 3,
        theme: colorsObject().blueVioletCrayola
      },
    }
  }
}

export const offers = {
  offersStatus: {
    label: 'Offers status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey
      },
      1: {
        label: 'Active',
        value: 1,
        theme: colorsObject().forrestGreenCrayola
      },
      2: {
        label: 'Test Mode',
        value: 2,
        theme: colorsObject().royalPurple
      },
      3: {
        label: 'Inactive',
        value: 3,
        theme: colorsObject().englishRed
      },
      4: {
        label: 'Suspended',
        value: 4,
        theme: colorsObject().darkByzantium
      },
    },
  },
  offersAccess: {
    label: 'Offers access',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      regular: {
        label: 'Regular',
        value: 'regular',
        theme: colorsObject().paolaVeroneseGreen,
      },
      vip: {
        label: 'Vip',
        value: 'vip',
        theme: colorsObject().ochre,
      },
      test: {
        label: 'Test',
        value: 'test',
        theme: colorsObject().royalPurple,
      },
      private: {
        label: 'Private',
        value: 'private',
        theme: colorsObject().starCommandBlue,
      },
    }
  },
  offersPaidStatus: {
    label: 'Offers paid status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Save from affiliate',
        value: 1,
        theme: colorsObject().starCommandBlue,
      },
      2: {
        label: 'Send to advertiser',
        value: 2,
        theme: colorsObject().rebeccaPurple,
      },
      3: {
        label: 'Hold',
        value: 3,
        theme: colorsObject().bdazzledBlue,
      },
      4: {
        label: 'Confirmed',
        value: 4,
        theme: colorsObject().bottleGreen,
      },
      5: {
        label: 'Cancelled',
        value: 5,
        theme: colorsObject().brickRed,
      },
      6: {
        label: 'Trash',
        value: 6,
        theme: colorsObject().rhythm,
      },
      7: {
        label: 'Unknown',
        value: 7,
        theme: colorsObject().darkByzantium,
      },
      8: {
        label: 'Buyout approved',
        value: 8,
        theme: colorsObject().littleBoyBlue,
      },
      9: {
        label: 'Buyout hold',
        value: 9,
        theme: colorsObject().olivine,
      },
      10: {
        label: 'Buyout rejected',
        value: 10,
        theme: colorsObject().paradisePink,
      },
    },
  },
  offersPaidStatusLimited: {
    label: 'Offers paid status limited',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      3: {
        label: 'Hold',
        value: 3,
        theme: colorsObject().bdazzledBlue,
      },
      4: {
        label: 'Confirmed',
        value: 4,
        theme: colorsObject().bottleGreen,
      },
    },
  },
  offersDeviceType: {
    label: 'Offers device type',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Mobile',
        value: 1,
        theme: colorsObject().ming,
        icon: 'mobile',
      },
      2: {
        label: 'Desktop',
        value: 2,
        theme: colorsObject().bdazzledBlue,
        icon: 'desktop',
      },
    },
  },
  offersCategory: {
    label: 'Offers category',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Leadgen',
        value: 1,
        theme: colorsObject().skobeloff,
      },
      2: {
        label: 'eCommerce',
        value: 2,
        theme: colorsObject().starCommandBlue,
      },
      3: {
        label: 'Mobile Content',
        value: 3,
        theme: colorsObject().jazzberryJam,
      },
      4: {
        label: 'App Installs',
        value: 4,
        theme: colorsObject().flickrPink,
      },
    },
  },
  offersVertical1: {
    label: 'Offers vertical leadgen (category 1)',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Software',
        value: 1,
        theme: colorsObject().lavenderFloral,
      },
      2: {
        label: 'Casino',
        value: 2,
        theme: colorsObject().turquoiseGreen,
      },
      3: {
        label: 'Forex',
        value: 3,
        theme: colorsObject().maximumBlueGreen,
      },
      4: {
        label: 'Dating',
        value: 4,
        theme: colorsObject().fuzzyWuzzy,
      },
      5: {
        label: 'Sweepstakes',
        value: 5,
        theme: colorsObject().fandago,
      },
      6: {
        label: 'Finance/Loans',
        value: 6,
        theme: colorsObject().bitterSweet,
      },
      7: {
        label: 'Gaming',
        value: 7,
        theme: colorsObject().maximumBluePurple,
      },
      8: {
        label: 'Social',
        value: 8,
        theme: colorsObject().orangeYellowCrayola,
      },
      9: {
        label: 'Shopping',
        value: 9,
        theme: colorsObject().mauve,
      },
      10: {
        label: 'Entertainment',
        value: 10,
        theme: colorsObject().lightBlue,
      },
      11: {
        label: 'SmartLink',
        value: 11,
        theme: colorsObject().keyLime,
      },
      12: {
        label: 'Crypto',
        value: 12,
        theme: colorsObject().amaranth,
      },
      13: {
        label: 'Betting',
        value: 13,
        theme: colorsObject().cherryBlossomPink,
      },
      14: {
        label: 'Cams',
        value: 14,
        theme: colorsObject().middleBluePurple,
      },
      15: {
        label: 'Lottery',
        value: 15,
        theme: colorsObject().maroonX11,
      },
      16: {
        label: 'Binary Options',
        value: 16,
        theme: colorsObject().midnightGreenEagleGreen,
      },
    },
  },
  offersFlow1: {
    label: 'Offers flow leadgen (category 1)',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'SOI',
        value: 1,
        theme: colorsObject().spaceCadet,
      },
      2: {
        label: 'DOI',
        value: 2,
        theme: colorsObject().brunswickGreen,
      },
      3: {
        label: 'IVR',
        value: 3,
        theme: colorsObject().barnRed,
      },
      4: {
        label: 'CPS',
        value: 4,
        theme: colorsObject().rebeccaPurple,
      },
      5: {
        label: 'Hybrid',
        value: 5,
        theme: colorsObject().darkLiverHorses,
      },
    }
  },
  offersVertical2: {
    label: 'Offers vertical eCommerce (category 2)',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Sex Toys',
        value: 1,
        theme: colorsObject().orangeYellowCrayola,
      },
      2: {
        label: 'Nail Fungi',
        value: 2,
        theme: colorsObject().mauve,
      },
      3: {
        label: 'Correctors',
        value: 3,
        theme: colorsObject().lightBlue,
      },
      4: {
        label: 'Cholesterol',
        value: 4,
        theme: colorsObject().keyLime,
      },
      5: {
        label: 'Health & Beauty',
        value: 5,
        theme: colorsObject().amaranth,
      },
      6: {
        label: 'Hairloss',
        value: 6,
        theme: colorsObject().cherryBlossomPink,
      },
      7: {
        label: 'Immunity',
        value: 7,
        theme: colorsObject().amaranth,
      },
      8: {
        label: 'Prostatitis',
        value: 8,
        theme: colorsObject().middleBluePurple,
      },
      9: {
        label: 'Eyesight',
        value: 9,
        theme: colorsObject().maroonX11,
      },
      10: {
        label: 'Blood Preassure',
        value: 10,
        theme: colorsObject().midnightGreenEagleGreen,
      },
      11: {
        label: 'Breast Enlargement',
        value: 11,
        theme: colorsObject().lavenderFloral,
      },
      12: {
        label: 'Bones',
        value: 12,
        theme: colorsObject().turquoiseGreen,
      },
      13: {
        label: 'Musle',
        value: 13,
        theme: colorsObject().maximumBlueGreen,
      },
      14: {
        label: 'Diabetes',
        value: 14,
        theme: colorsObject().fuzzyWuzzy,
      },
      15: {
        label: 'Skin Immunity',
        value: 15,
        theme: colorsObject().fandago,
      },
      16: {
        label: 'Fertility Problems',
        value: 16,
        theme: colorsObject().bitterSweet,
      },
      17: {
        label: 'Beauty',
        value: 17,
        theme: colorsObject().maximumBluePurple,
      },
      18: {
        label: 'Acne',
        value: 18,
        theme: colorsObject().orangeYellowCrayola,
      },
      19: {
        label: 'Joints',
        value: 19,
        theme: colorsObject().mauve,
      },
      20: {
        label: 'Health Produts',
        value: 20,
        theme: colorsObject().lightBlue,
      },
      21: {
        label: 'Potency',
        value: 21,
        theme: colorsObject().keyLime,
      },
      22: {
        label: 'Accessories',
        value: 22,
        theme: colorsObject().amaranth,
      },
    },
  },
  offersFlow2: {
    label: 'Offers flow eCommerce (category 2)',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'CPL',
        value: 1,
        theme: colorsObject().eggplant,
      },
      2: {
        label: 'COD',
        value: 2,
        theme: colorsObject().englishViolet,
      },
      3: {
        label: 'CPS',
        value: 3,
        theme: colorsObject().feldgrau,
      },
    },
  },
  offersVertical3: {
    label: 'Offers vertical Mobile Content (category 3)',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'VOD',
        value: 1,
        theme: colorsObject().cherryBlossomPink,
      },
      2: {
        label: 'Gaming',
        value: 2,
        theme: colorsObject().middleBluePurple,
      },
      3: {
        label: 'Antivirus / Security',
        value: 3,
        theme: colorsObject().maroonX11,
      },
      4: {
        label: 'Generic Download',
        value: 4,
        theme: colorsObject().midnightGreenEagleGreen,
      },
      5: {
        label: 'Dating',
        value: 5,
        theme: colorsObject().lavenderFloral,
      },
    },
  },
  offersFlow3: {
    label: 'Offers flow Mobile Content (category 3)',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Pin Submit',
        value: 1,
        theme: colorsObject().redwood,
      },
      2: {
        label: 'DCB- Other',
        value: 2,
        theme: colorsObject().midnightEagleGreen,
      },
      3: {
        label: 'DCB - 1 - Click',
        value: 3,
        theme: colorsObject().amaranth,
      },
    },
  },
  offersVertical4: {
    label: 'Offers vertical App Installs (category 4)',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Shopping',
        value: 1,
        theme: colorsObject().turquoiseGreen,
      },
      2: {
        label: 'Games',
        value: 2,
        theme: colorsObject().maximumBlueGreen,
      },
      3: {
        label: 'Travel',
        value: 3,
        theme: colorsObject().fuzzyWuzzy,
      },
      4: {
        label: 'Casino',
        value: 4,
        theme: colorsObject().fandago,
      },
    },
  },
  offersFlow4: {
    label: 'Offers flow App Installs (category 4)',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Install & Open',
        value: 1,
        theme: colorsObject().sugarPlum,
      },
      2: {
        label: 'Registration',
        value: 2,
        theme: colorsObject().darkPink,
      },
      3: {
        label: 'Sale',
        value: 3,
        theme: colorsObject().darkSlateGray,
      },
    },
  },
  offersFavorite: {
    label: 'Offers favorite',
    data: {
      default: {
        label: 'Not favorite',
        value: null,
        theme: colorsObject().englishRed,
      },
      true: {
        label: 'Favorite',
        value: 'true',
        theme: colorsObject().forrestGreenCrayola,
      },
      false: {
        label: 'Not favorite',
        value: 'false',
        theme: colorsObject().englishRed,
      },
    },
  }
}

export const offersAccess = {
  offersAccessStatus: {
    label: 'Offers access status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      '1': {
        label: 'Pending',
        value: 1,
        theme: colorsObject().burntSienna,
      },
      '2': {
        label: 'Approved',
        value: 2,
        theme: colorsObject().forrestGreenCrayola,
      },
      '3': {
        label: 'Rejected',
        value: 3,
        theme: colorsObject().englishRed,
      },
    }
  }
}

export const offersPayouts = {
  offersPayoutsTable: {
    label: 'Offers payouts table',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      'users': {
        label: 'Users',
        value: 'users',
        theme: colorsObject().skobeloff,
      },
      'offers': {
        label: 'Offers',
        value: 'offers',
        theme: colorsObject().starCommandBlue,
      }
    }
  }
}

export const prelandings = {
  prelandingsCategory: {
    label: 'Prelandings Category',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey
      },
      1: {
        label: 'Test Category',
        value: 1,
        theme: colorsObject().cerise
      }
    }
  },
  prelandingsStatus: {
    label: 'Prelandings Status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey
      },
      1: {
        label: 'Active',
        value: 1,
        theme: colorsObject().forrestGreenCrayola
      },
      2: {
        label: 'Inactive',
        value: 2,
        theme: colorsObject().englishRed
      }
    }
  }
}

export const groups = {
  groupsStatus: {
    label: 'Groups status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      active: {
        label: 'Active',
        value: 'active',
        theme: colorsObject().forrestGreenCrayola,
      },
      inactive: {
        label: 'Inactive',
        value: 'inactive',
        theme: colorsObject().englishRed,
      },
    }
  },
}

export const landings = {
  landingStatus: {
    label: 'Landing status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Active',
        value: 1,
        theme: colorsObject().forrestGreenCrayola,
      },
      2: {
        label: 'Inactive',
        value: 2,
        theme: colorsObject().englishRed,
      },
    }
  },
  landingCategory: {
    label: 'Landing category',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Test Category',
        value: 1,
        theme: colorsObject().cerise,
      },
    }
  },
}

export const payments = {
  paymentsMethod: {
    label: 'Payments method',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey
      },
      wire: {
        label: 'Wire',
        value: 'wire',
        theme: colorsObject().feldgrau
      },
      paypal: {
        label: 'Paypal',
        value: 'paypal',
        theme: colorsObject().starCommandBlue
      },
      tipalti: {
        label: 'Tipalti',
        value: 'tipalti',
        theme: colorsObject().royalPurple
      }
    }
  },
  paymentsStatus: {
    label: 'Payments status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey
      },
      1: {
        label: 'Created',
        value: 1,
        theme: colorsObject().bdazzledBlue
      },
      2: {
        label: 'Approved',
        value: 2,
        theme: colorsObject().bottleGreen
      },
      3: {
        label: 'Rejected',
        value: 3,
        theme: colorsObject().brickRed
      },
      4: {
        label: 'Paid',
        value: 4,
        theme: colorsObject().lightGreenCustom
      },
      5: {
        label: 'Returned',
        value: 5,
        theme: colorsObject().pumpkin
      }
    }
  },
  paymentsType: {
    label: 'Payments type',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey
      },
      1: {
        label: 'Payout',
        value: 1,
        theme: colorsObject().ming
      },
      2: {
        label: 'Transfer',
        value: 2,
        theme: colorsObject().bdazzledBlue
      }
    }
  },
}

export const orders = {
  ordersStatus: {
    label: 'Orders status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey
      },
      1: {
        label: 'Save from affiliate',
        value: 1,
        theme: colorsObject().starCommandBlue
      },
      2: {
        label: 'Send to advertiser',
        value: 2,
        theme: colorsObject().rebeccaPurple
      },
      3: {
        label: 'Hold',
        value: 3,
        theme: colorsObject().bdazzledBlue
      },
      4: {
        label: 'Confirmed',
        value: 4,
        theme: colorsObject().bottleGreen
      },
      5: {
        label: 'Cancelled',
        value: 5,
        theme: colorsObject().brickRed
      },
      6: {
        label: 'Trash',
        value: 6,
        theme: colorsObject().rhythm
      },
      7: {
        label: 'Unknown',
        value: 7,
        theme: colorsObject().darkByzantium
      },
      8: {
        label: 'Buyout approved',
        value: 8,
        theme: colorsObject().littleBoyBlue
      },
      9: {
        label: 'Buyout hold',
        value: 9,
        theme: colorsObject().olivine
      },
      10: {
        label: 'Buyout rejected',
        value: 10,
        theme: colorsObject().paradisePink
      },
      11: {
        label: 'Error',
        value: 11,
        theme: colorsObject().englishRed
      }
    }
  },
  orderStatusLimited: {
    label: 'Orders status limited',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey
      },
      1: {
        label: 'Save from affiliate',
        value: 1,
        theme: colorsObject().starCommandBlue
      },
      2: {
        label: 'Send to advertiser',
        value: 2,
        theme: colorsObject().rebeccaPurple
      },
      3: {
        label: 'Hold',
        value: 3,
        theme: colorsObject().bdazzledBlue
      },
      4: {
        label: 'Confirmed',
        value: 4,
        theme: colorsObject().bottleGreen
      },
      5: {
        label: 'Cancelled',
        value: 5,
        theme: colorsObject().brickRed
      },
      6: {
        label: 'Trash',
        value: 6,
        theme: colorsObject().rhythm
      },
      7: {
        label: 'Unknown',
        value: 7,
        theme: colorsObject().darkByzantium
      },
    }
  }
}

export const bids = {
  bidsStrategy: {
    label: 'Bids strategy',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      exact: {
        label: 'Exact',
        value: 'exact',
        theme: colorsObject().russianGreen,
      },
      floorAdd: {
        label: 'Floor add',
        value: 'floor_add',
        theme: colorsObject().feldgrau,
      },
      floorMultiply: {
        label: 'Floor multiply',
        value: 'floor_multiply',
        theme: colorsObject().unbleachedSilk,
      },
      priceAdd: {
        label: 'Price add',
        value: 'price_add',
        theme: colorsObject().middleBluePurple,
      },
      priceMultiply: {
        label: 'Price multiply',
        value: 'price_multiply',
        theme: colorsObject().englishRed,
      }
    },
  },
  bidsModel: {
    label: 'Bids model',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      cpc: {
        label: 'CPC',
        value: 'cpc',
        theme: colorsObject().amazon,
      },
      cpm: {
        label: 'CPM',
        value: 'cpm',
        theme: colorsObject().englishRed,
      }
    },
  }
}



export const loginHistory = {
  loginHistoryStatus: {
    label: 'Login History Status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Success',
        value: 1,
        theme: colorsObject().forrestGreenCrayola,
      },
      2: {
        label: 'Error',
        value: 2,
        theme: colorsObject().englishRed,
      }
    },
  },
  loginHistoryDevice: {
    label: 'Login History Device',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      'desktop': {
        label: 'Desktop',
        value: 'desktop',
        theme: colorsObject().fuzzyWuzzy,
      },
      'mobile': {
        label: 'Mobile',
        value: 'mobile',
        theme: colorsObject().bdazzledBlue,
      },
      'tablet': {
        label: 'tablet',
        value: 'tablet',
        theme: colorsObject().blueVioletCrayola,
      }
    },
  },
}

export const ordersErrors = {
  ordersErrorsStatus: {
    label: 'Orders errors status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey
      },
      'not_resolved': {
        label: 'Not resolved',
        value: 'not_resolved',
        theme: colorsObject().brickRed
      },
      'resolved': {
        label: 'Resolved',
        value: 'resolved',
        theme: colorsObject().paolaVeroneseGreen
      },
    }
  }
}

export const logsQueueEmail = {
  logsQueueEmailStatus: {
    label: 'Logs Queue Email Status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      0: {
        label: 'Wait for process',
        value: 0,
        theme: colorsObject().burntSienna,
      },
      1: {
        label: 'Done',
        value: 1,
        theme: colorsObject().bottleGreen,
      },
      2: {
        label: 'Failed',
        value: 2,
        theme: colorsObject().englishRed,
      },
    },
  },
  logsQueueEmailTemplate: {
    label: 'Queue email template',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      'change-password': {
        label: 'Password change',
        value: 'change-password',
        theme: colorsObject().amazon,
      },
      'verification-account': {
        label: 'Account verification',
        value: 'verification-account',
        theme: colorsObject().bdazzledBlue,
      },
      "welcome": {
        label: 'Welcome',
        value: 'welcome',
        theme: colorsObject().forrestGreenCrayola,
      },
      'topups-payment-creditcard-paid': {
        label: 'Credit card paid',
        value: 'topups-payment-creditcard-paid',
        theme: colorsObject().burntSienna,
      },
      'approved_campaign': {
        label: 'Campaign approved',
        value: 'approved_campaign',
        theme: colorsObject().rebeccaPurple,
      },
      'forgot-password': {
        label: 'Forgot password',
        value: 'forgot-password',
        theme: colorsObject().brickRed
      },
      'approved_creative': {
        label: 'Creative approved',
        value: 'approved_creative',
        theme: colorsObject().rhythm
      },
      'reject_creative': {
        label: 'Creative rejected',
        value: 'reject_creative',
        theme: colorsObject().darkByzantium
      },
      'approved-account': {
        label: 'Account approved',
        value: 8,
        theme: colorsObject().littleBoyBlue
      },
      'all_campaign_paused': {
        label: 'All campaigns paused',
        value: 'all_campaign_paused',
        theme: colorsObject().olivine
      },
      'reject_user': {
        label: 'User rejected',
        value: 'reject_user',
        theme: colorsObject().paradisePink
      },
    },
  },
}

export const topups = {
  topupsType: {
    label: 'Topups type',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      creditcard: {
        label: 'Credit card',
        value: 'creditcard',
        theme: colorsObject().starCommandBlue,
      },
      wire: {
        label: 'Wire',
        value: 'wire',
        theme: colorsObject().vividTangarine,
      },
      coupon: {
        label: 'coupon',
        value: 'coupon',
        theme: colorsObject().rhythm,
      }
    },
  },
  topupsStatus: {
    label: 'Topups status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      created: {
        label: 'Created',
        value: 'created',
        theme: colorsObject().bdazzledBlue,
      },
      paid: {
        label: 'Paid',
        value: 'paid',
        theme: colorsObject().bottleGreen,
      },
      rejects: {
        label: 'Rejected',
        value: 'rejects',
        theme: colorsObject().brickRed,
      }
    },
  },
}

export const changeLog = {
  changeLogChangeGroup: {
    label: 'Change log change group',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'General',
        value: 1,
        theme: colorsObject().orangeYellowCrayola,
      },
      2: {
        label: 'Admin',
        value: 2,
        theme: colorsObject().amazon,
      },
      3: {
        label: 'Affiliate',
        value: 3,
        theme: colorsObject().starCommandBlue,
      },
      4: {
        label: 'Advertiser',
        value: 4,
        theme: colorsObject().rebeccaPurple,
      },
    },
  },
  changeLogType: {
    label: 'Change log type',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Improvement',
        value: 1,
        theme: colorsObject().bottleGreen,
      },
      2: {
        label: 'Bug fix',
        value: 2,
        theme: colorsObject().starCommandBlue,
      },
      3: {
        label: 'New feature',
        value: 3,
        theme: colorsObject().amazon,
      }
    },
  }
}

export const postback = {
  postbackStatus: {
    label: 'Postback Status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Active',
        value: 1,
        theme: colorsObject().forrestGreenCrayola,
      },
      2: {
        label: 'Inactive',
        value: 2,
        theme: colorsObject().englishRed,
      },
    },
  },
  postbackType: {
    label: "Postback Type",
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Lead',
        value: 1,
        theme: colorsObject().ming,
      },

      2: {
        label: 'Event',
        value: 2,
        theme: colorsObject().bdazzledBlue,
      },
    }
  },
  postbackLevel: {
    label: "Postback Level",
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'Global',
        value: 1,
        theme: colorsObject().starCommandBlue,
      },

      2: {
        label: 'Specific',
        value: 2,
        theme: colorsObject().royalPurple,
      },
    }
  },
  postbacksEvent: {
    label: "Postbacks Event",
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      3: {
        label: 'Hold',
        value: 3,
        theme: colorsObject().bdazzledBlue,
      },

      4: {
        label: 'Confirmed',
        value: 4,
        theme: colorsObject().bottleGreen,
      },
      5: {
        label: 'Cancelled',
        value: 5,
        theme: colorsObject().brickRed,
      },

      6: {
        label: 'Trash',
        value: 6,
        theme: colorsObject().rhythm,
      },
      7: {
        label: 'Unknown',
        value: 7,
        theme: colorsObject().darkByzantium,
      },

      8: {
        label: 'Buyout approved',
        value: 8,
        theme: colorsObject().littleBoyBlue,
      },
      9: {
        label: 'Buyout hold',
        value: 9,
        theme: colorsObject().olivine,
      },

      10: {
        label: 'Buyout rejected',
        value: 10,
        theme: colorsObject().paradisePink,
      },
    }
  },
  postbacksEventStandard: {
    label: "Postbacks Event Standard",
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      3: {
        label: 'Hold',
        value: 3,
        theme: colorsObject().bdazzledBlue,
      },

      4: {
        label: 'Confirmed',
        value: 4,
        theme: colorsObject().bottleGreen,
      },
      5: {
        label: 'Cancelled',
        value: 5,
        theme: colorsObject().brickRed,
      },

      6: {
        label: 'Trash',
        value: 6,
        theme: colorsObject().rhythm,
      }
    }
  },
  postbacksMethod: {
    label: "Postbacks Methods",
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'S2S',
        value: 1,
        theme: colorsObject().feldgrau,
      }
    }
  },
  postbacksMethodTemp: {
    label: "Postbacks Methods Temp",
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: 'S2S',
        value: 1,
        theme: colorsObject().feldgrau,
      }
    }
  }
}

export const postbackLogs = {
  postbackLogsStatus: {
    label: 'Postback Logs Status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      success: {
        label: 'Success',
        value: 'success',
        theme: colorsObject().forrestGreenCrayola,
      },

      error: {
        label: 'Error',
        value: 'error',
        theme: colorsObject().englishRed,
      },
    },
  }
}

export const httpCode = {
  httpCodeStatus: {
    label: 'Htpp code status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey
      },
      0: {
        label: '0 Resposne not received',
        value: 0,
        theme: colorsObject().darkByzantium
      },
      200: {
        label: '200 OK',
        value: 200,
        theme: colorsObject().forrestGreenCrayola
      },
      202: {
        label: '202 Accepted',
        value: 202,
        theme: colorsObject().forrestGreenCrayola
      },
      203: {
        label: '203 Non-Authoritative Information',
        value: 203,
        theme: colorsObject().forrestGreenCrayola
      },
      204: {
        label: '204 No Content',
        value: 204,
        theme: colorsObject().forrestGreenCrayola
      },
      205: {
        label: '205 Reset Content',
        value: 205,
        theme: colorsObject().forrestGreenCrayola
      },
      206: {
        label: '206 Partial Content',
        value: 206,
        theme: colorsObject().forrestGreenCrayola
      },
      300: {
        label: '300 Multiple Choice',
        value: 300,
        theme: colorsObject().forrestGreenCrayola
      },
      301: {
        label: '301 Moved permanently',
        value: 301,
        theme: colorsObject().sunray
      },
      302: {
        label: '302 Found',
        value: 302,
        theme: colorsObject().sunray
      },
      303: {
        label: '303 See Other',
        value: 303,
        theme: colorsObject().sunray
      },
      304: {
        label: '304 Not modified',
        value: 304,
        theme: colorsObject().sunray
      },
      307: {
        label: '307 Temporary Redirect',
        value: 305,
        theme: colorsObject().sunray
      },
      308: {
        label: '308 Permament Redirect',
        value: 308,
        theme: colorsObject().sunray
      },
      400: {
        label: '400 Bad Request',
        value: 400,
        theme: colorsObject().burntSienna
      },
      401: {
        label: '401 Unathorized',
        value: 401,
        theme: colorsObject().burntSienna
      },
      403: {
        label: '403 Forbidden',
        value: 403,
        theme: colorsObject().burntSienna
      },
      405: {
        label: '405 Method Not Allowed',
        value: 405,
        theme: colorsObject().burntSienna
      },
      406: {
        label: '406 Not Acceptable',
        value: 406,
        theme: colorsObject().burntSienna
      },
      407: {
        label: '407 Proxy Authentication Required',
        value: 407,
        theme: colorsObject().burntSienna
      },
      408: {
        label: '408 Request Timeout',
        value: 408,
        theme: colorsObject().burntSienna
      },
      409: {
        label: '409 Conflict',
        value: 409,
        theme: colorsObject().burntSienna
      },
      410: {
        label: '410 Gone',
        value: 410,
        theme: colorsObject().burntSienna
      },
      411: {
        label: '411 Length Required',
        value: 411,
        theme: colorsObject().burntSienna
      },
      412: {
        label: '412 Precondition Failed',
        value: 412,
        theme: colorsObject().burntSienna
      },
      413: {
        label: '412 Payload Too Large',
        value: 413,
        theme: colorsObject().burntSienna
      },
      414: {
        label: '414 Uri Too Long',
        value: 414,
        theme: colorsObject().burntSienna
      },
      415: {
        label: '415 Unsupported Media Type',
        value: 414,
        theme: colorsObject().burntSienna
      },
      416: {
        label: '416 Range Not Satisfiable',
        value: 416,
        theme: colorsObject().burntSienna
      },
      417: {
        label: '417 Expectation Failed',
        value: 417,
        theme: colorsObject().burntSienna
      },
      426: {
        label: '426 Upgrade Required',
        value: 426,
        theme: colorsObject().burntSienna
      },
      428: {
        label: '428 Precondition Required',
        value: 428,
        theme: colorsObject().burntSienna
      },
      429: {
        label: '429 Too Many Requests',
        value: 429,
        theme: colorsObject().burntSienna
      },
      431: {
        label: '431 Request Header Fields Too Large',
        value: 431,
        theme: colorsObject().burntSienna
      },
      500: {
        label: '500 Internal Server Error',
        value: 500,
        theme: colorsObject().englishRed
      },
      501: {
        label: '501 Not Implemented',
        value: 501,
        theme: colorsObject().englishRed
      },
      502: {
        label: '502 Bad Gateway',
        value: 502,
        theme: colorsObject().englishRed
      },
      503: {
        label: '503 Service Unavailable',
        value: 503,
        theme: colorsObject().englishRed
      },
      504: {
        label: '504 Gateway Timeout',
        value: 504,
        theme: colorsObject().englishRed
      },
      505: {
        label: '505 HTTP Version Not Supported',
        value: 505,
        theme: colorsObject().englishRed
      },
      510: {
        label: '510 Not Extended',
        value: 510,
        theme: colorsObject().englishRed
      },
      511: {
        label: '511 Network Authentication Required',
        value: 511,
        theme: colorsObject().englishRed
      },
    }
  }
}

export const campaigns = {
  campaignModel: {
    label: 'Campaign model',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      native: {
        label: 'Native',
        value: 'native',
        theme: colorsObject().amazon,
      },
      push: {
        label: 'Push',
        value: 'push',
        theme: colorsObject().burntSienna,
      },
      "in-page-push": {
        label: 'In Page Push',
        value: 'in-page-push',
        theme: colorsObject().flickrPink,
      },
      pop: {
        label: 'Pop',
        value: 'pop',
        theme: colorsObject().burntSienna,
      },
      smart: {
        label: 'Smart',
        value: 'smart',
        theme: colorsObject().rebeccaPurple,
      },
    },
  },
  campaignStatus: {
    label: 'Campaign status',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      active: {
        label: 'Active',
        value: 'active',
        theme: colorsObject().forrestGreenCrayola,
      },
      paused: {
        label: 'Paused',
        value: 'paused',
        theme: colorsObject().orangeYellowCrayola,
      },
      archive: {
        label: 'Archive',
        value: 'archive',
        theme: colorsObject().bdazzledBlue,
      },
      suspended: {
        label: 'Suspended',
        value: 'suspended',
        theme: colorsObject().bottleGreen,
      },
      disabled: {
        label: 'Disabled',
        value: 'disabled',
        theme: colorsObject().brickRed,
      },
      "hourly-limit": {
        label: 'Hourly limit',
        value: 'hourly-limit',
        theme: colorsObject().starCommandBlue,
      },
      "daily-limit": {
        label: 'Daily limit',
        value: 'daily-limit',
        theme: colorsObject().darkByzantium,
      },
      "monthly-limit": {
        label: 'Monthly limit',
        value: 'monthly-limit',
        theme: colorsObject().littleBoyBlue,
      },
      "lifetime-limit": {
        label: 'Lifetime limit',
        value: 'lifetime-limit',
        theme: colorsObject().fuzzyWuzzy,
      },
      implementing: {
        label: 'Implementing',
        value: 'implementing',
        theme: colorsObject().olivine,
      },
      pending: {
        label: 'Pending',
        value: 'pending',
        theme: colorsObject().olivine,
      },
      delete: {
        label: 'Delete',
        value: 'delete',
        theme: colorsObject().rhythm,
      },
    },
  },
  campaignPricingModel: {
    label: 'Campaign pricing model',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      cpc: {
        label: 'CPC',
        value: 'cpc',
        theme: colorsObject().fuzzyWuzzy,
      },
      cpm: {
        label: 'CPM',
        value: 'cpm',
        theme: colorsObject().bdazzledBlue,
      },
      cpa: {
        label: 'CPA',
        value: 'cpa',
        theme: colorsObject().blueVioletCrayola,
      },
    }
  },
  campaignType: {
    label: 'Campaign type',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      internal: {
        label: 'Internal',
        value: 'internal',
        theme: colorsObject().starCommandBlue,
      },
      external: {
        label: 'External',
        value: 'external',
        theme: colorsObject().royalPurple,
      }
    }
  },
}



export const affiliateReport = {
  statsBasedOn: {
    label: 'Status based on',
    data: {
      offer: {
        label: 'Offer',
        value: 'offer',
        theme: colorsObject().forrestGreenCrayola
      },
      date: {
        label: 'Date',
        value: 'date',
        theme: colorsObject().forrestGreenCrayola
      },
      month: {
        label: 'Month',
        value: 'month',
        theme: colorsObject().forrestGreenCrayola
      },
      day_of_week: {
        label: 'Day of week',
        value: 'day_of_week',
        theme: colorsObject().forrestGreenCrayola
      },
      time: {
        label: 'Time',
        value: 'time',
        theme: colorsObject().forrestGreenCrayola
      },
      hour_of_day: {
        label: 'Hour of day',
        value: 'hour_of_day',
        theme: colorsObject().forrestGreenCrayola
      },
      landings: {
        label: 'Landings',
        value: 'landings',
        theme: colorsObject().forrestGreenCrayola
      },
      prelandings: {
        label: 'Prelandings',
        value: 'prelandings',
        theme: colorsObject().forrestGreenCrayola
      },
      country_code: {
        label: 'Country',
        value: 'country_code',
        theme: colorsObject().forrestGreenCrayola
      },
      sub_1: {
        label: 'Sub 1',
        value: 'sub_1',
        theme: colorsObject().forrestGreenCrayola
      },
      sub_2: {
        label: 'Sub 2',
        value: 'sub_2',
        theme: colorsObject().forrestGreenCrayola
      },
      sub_3: {
        label: 'Sub 3',
        value: 'sub_3',
        theme: colorsObject().forrestGreenCrayola
      },
      sub_4: {
        label: 'Sub 4',
        value: 'sub_4',
        theme: colorsObject().forrestGreenCrayola
      },
      utm_campaign: {
        label: 'UTM campaign',
        value: 'utm_campaign',
        theme: colorsObject().forrestGreenCrayola
      },
      utm_source: {
        label: 'UTM source',
        value: 'utm_source',
        theme: colorsObject().forrestGreenCrayola
      },
      utm_medium: {
        label: 'UTM medium',
        value: 'utm_medium',
        theme: colorsObject().forrestGreenCrayola
      },
      utm_term: {
        label: 'UTM term',
        value: 'utm_term',
        theme: colorsObject().forrestGreenCrayola
      },
      utm_content: {
        label: 'UTM content',
        value: 'utm_content',
        theme: colorsObject().forrestGreenCrayola
      },
      device_type: {
        label: 'Device type',
        value: 'device_type',
        theme: colorsObject().forrestGreenCrayola
      },
      browser_name: {
        label: 'Browser name',
        value: 'browser_name',
        theme: colorsObject().forrestGreenCrayola
      },
      browser_version: {
        label: 'Browser version',
        value: 'browser_version',
        theme: colorsObject().forrestGreenCrayola
      },
      os_name: {
        label: 'OS name',
        value: 'os_name',
        theme: colorsObject().forrestGreenCrayola
      },
      os_version: {
        label: 'OS version',
        value: 'os_version',
        theme: colorsObject().forrestGreenCrayola
      },
    }
  }
}


//OLD ENUMS

export const enumUserStatus = {
  default: {
    label: "Admin",
    value: 1,
    color: c.amazon.textColor,
    background: c.amazon.background,
  },
  1: {
    label: "Admin",
    value: 1,
    color: c.amazon.textColor,
    background: c.amazon.background,
  },
  2: {
    label: "Account Manager",
    value: 2,
    color: c.burntSienna.textColor,
    background: c.burntSienna.background,
  },
  3: {
    label: "Finance",
    value: 3,
    color: c.flickrPink.textColor,
    background: c.flickrPink.background,
  },
  4: {
    label: "Support",
    value: 4,
    color: c.amaranth.textColor,
    background: c.amaranth.background,
  },
  5: {
    label: "Advertiser",
    value: 5,
    color: c.rebeccaPurple.textColor,
    background: c.rebeccaPurple.background,
  },
  99: {
    label: "Banned",
    value: 99,
    color: c.englishRed.textColor,
    background: c.englishRed.background,
  },
};

export const enumUserType = {
  default: {
    label: "Internal",
    value: 1,
    color: c.starCommandBlue.textColor,
    background: c.starCommandBlue.background,
  },
  1: {
    label: "Internal",
    value: 1,
    color: c.starCommandBlue.textColor,
    background: c.starCommandBlue.background,
  },
  2: {
    label: "External",
    value: 2,
    color: c.royalPurple.textColor,
    background: c.royalPurple.background,
  },
};

export const enumUserPayment = {
  default: {
    label: "Inactive",
    value: false,
    color: c.englishRed.textColor,
    background: c.englishRed.background,
  },
  true: {
    label: "Active",
    value: true,
    color: c.forrestGreenCrayola.textColor,
    background: c.forrestGreenCrayola.background,
  },
  false: {
    label: "Inactive",
    value: false,
    color: c.englishRed.textColor,
    background: c.englishRed.background,
  },
}

export const enumLoginHistoryStatus = {
  default: {
    label: 'N/A',
    value: null,
    color: c.cadetGrey.textColor,
    background: c.cadetGrey.background,
  },
  1: {
    label: 'Success',
    value: 1,
    color: c.forrestGreenCrayola.textColor,
    background: c.forrestGreenCrayola.background,
  },
  2: {
    label: 'Error',
    value: 2,
    color: c.englishRed.textColor,
    background: c.englishRed.background,
  },
}

export const enumCampaignsModel = {
  default: {
    label: 'Native',
    value: 'native',
    color: c.amazon.textColor,
    background: c.amazon.background,
  },
  native: {
    label: 'Native',
    value: 'native',
    color: c.amazon.textColor,
    background: c.amazon.background,
  },
  push: {
    label: 'Push',
    value: 'push',
    color: c.burntSienna.textColor,
    background: c.burntSienna.background,
  },
  'in-page-push': {
    label: 'In Page Push',
    value: 'in-page-push',
    color: c.flickrPink.textColor,
    background: c.flickrPink.background,
  },
  'pop': {
    label: 'Pop',
    value: 'pop',
    color: c.amaranth.textColor,
    background: c.amaranth.background,
  },
  'smart': {
    label: 'Smart',
    value: 'smart',
    color: c.rebeccaPurple.textColor,
    background: c.rebeccaPurple.background,
  },
}

export const enumCampaignsStatusAfterApproved = {
  default: {
    label: 'Paused',
    value: 'paused',
    color: c.englishRed.textColor,
    background: c.englishRed.background,
  },
  active: {
    label: 'Active',
    value: 'active',
    color: c.forrestGreenCrayola.textColor,
    background: c.forrestGreenCrayola.background,
  },
  paused: {
    label: 'Paused',
    value: 'paused',
    color: c.englishRed.textColor,
    background: c.englishRed.background,
  },
}

export const enumCampaignsPricingModel = {
  default: {
    label: 'N/A',
    value: null,
    color: c.cadetGrey.textColor,
    background: c.cadetGrey.background,
  },
  cpc: {
    label: 'CPC',
    value: 'cpc',
    color: c.fuzzyWuzzy.textColor,
    background: c.fuzzyWuzzy.background,
  },
  cpm: {
    label: 'CPM',
    value: 'cpm',
    color: c.bdazzledBlue.textColor,
    background: c.bdazzledBlue.background,
  },
  cpa: {
    label: 'CPA',
    value: 'cpa',
    color: c.blueVioletCrayola.textColor,
    background: c.blueVioletCrayola.background,
  },
}

export const enumCampaignsSync = {
  default: {
    label: 'N/A',
    value: null,
    color: c.cadetGrey.textColor,
    background: c.cadetGrey.background,
  },
  'yes': {
    label: 'Yes',
    value: 'yes',
    color: c.forrestGreenCrayola.textColor,
    background: c.forrestGreenCrayola.background,
  },
  'no': {
    label: 'No',
    value: 'no',
    color: c.darkByzantium.textColor,
    background: c.darkByzantium.background,
  },
  'in_progress': {
    label: 'In progress',
    value: 'in_progress',
    color: c.royalPurple.textColor,
    background: c.royalPurple.background,
  },
}

export const enumCampaignsAction = {
  default: {
    label: 'N/A',
    value: null,
    color: c.cadetGrey.textColor,
    background: c.cadetGrey.background,
  },
  create: {
    label: 'Created',
    value: 'create',
    color: c.bdazzledBlue.textColor,
    background: c.bdazzledBlue.background,
  },
  update: {
    label: 'Update',
    value: 'update',
    color: c.bottleGreen.textColor,
    background: c.bottleGreen.background,
  },
  delete: {
    label: 'Delete',
    value: 'delete',
    color: c.brickRed.textColor,
    background: c.brickRed.background,
  },
}

export const enumCampaignsType = {
  default: {
    label: 'Internal',
    value: 1,
    color: c.starCommandBlue.textColor,
    background: c.starCommandBlue.background,
  },
  internal: {
    label: 'Internal',
    value: 'internal',
    color: c.starCommandBlue.textColor,
    background: c.starCommandBlue.background,
  },
  external: {
    label: 'External',
    value: 'external',
    color: c.royalPurple.textColor,
    background: c.royalPurple.background,
  },
}

export const enumCampaignsStatus = {
  default: {
    label: 'N/A',
    color: c.cadetGrey.textColor,
    background: c.cadetGrey.background,
  },
  active: {
    label: 'Active',
    value: 'active',
    color: c.forrestGreenCrayola.textColor,
    background: c.forrestGreenCrayola.background,
  },
  paused: {
    label: 'Paused',
    value: 'paused',
    color: c.englishRed.textColor,
    background: c.englishRed.background,
  },
  archive: {
    label: 'Archive',
    value: 'archive',
    color: c.bdazzledBlue.textColor,
    background: c.bdazzledBlue.background,
  },
  suspended: {
    label: 'Suspended',
    value: 'suspended',
    color: c.bottleGreen.textColor,
    background: c.bottleGreen.background,
  },
  disabled: {
    label: 'disabled',
    value: 'disabled',
    color: c.brickRed.textColor,
    background: c.brickRed.background,
  },
  'hourly-limit': {
    label: 'Hourly Limit',
    value: 'hourly-limit',
    color: c.starCommandBlue.textColor,
    background: c.starCommandBlue.background,
  },
  'daily-limit': {
    label: 'Daily- Limit',
    value: 'daily-limit',
    color: c.darkByzantium.textColor,
    background: c.darkByzantium.background,
  },
  'monthly-limit': {
    label: 'Monthly Limit',
    value: 'monthly-limit',
    color: c.littleBoyBlue.textColor,
    background: c.littleBoyBlue.background,
  },
  implementing: {
    label: 'Implementing',
    value: 'implementing',
    color: c.olivine.textColor,
    background: c.olivine.background,
  },
  pending: {
    label: 'Pending',
    value: 'pending',
    color: c.paradisePink.textColor,
    background: c.paradisePink.background,
  },
  delete: {
    label: 'Delete',
    value: 'delete',
    color: c.rhythm.textColor,
    background: c.rhythm.background,
  },
}

export const enumAudienceOption = {
  default: {
    label: "Include",
    value: "include",
  },
  is: {
    label: "Include",
    value: "include",
  },
  is_not: {
    label: "Exclude",
    value: "exclude",
  },
};

export const enumOsOption = {
  default: {
    label: "EXACT",
    value: "exact",
  },
  exact: {
    label: "EXACT",
    value: "exact",
  },
  min_version: {
    label: "MIN VERSION",
    value: "min_version",
  },
};

export const enumAudienceCountry = {
  default: {
    label: "Bosnia and Herzegovina",
    value: "BA",
    image: "https://api.monadlead.com/storage/country/flags/32x32/ba.png",
  },
  ba: {
    label: "Bosnia and Herzegovina",
    value: "BA",
    image: "https://api.monadlead.com/storage/country/flags/32x32/ba.png",
  },
  rs: {
    label: "Serbia",
    value: "RS",
    image: "https://api.monadlead.com/storage/country/flags/32x32/rs.png",
  },
};

export const enumAudienceMonths = [
  {
    label: "January",
    value: 1,
  },
  {
    label: "February",
    value: 2,
  },
  {
    label: "March",
    value: 3,
  },
  {
    label: "April",
    value: 4,
  },
  {
    label: "May",
    value: 5,
  },
  {
    label: "June",
    value: 6,
  },
  {
    label: "July",
    value: 7,
  },
  {
    label: "August",
    value: 8,
  },
  {
    label: "September",
    value: 9,
  },
  {
    label: "October",
    value: 10,
  },
  {
    label: "November",
    value: 11,
  },
  {
    label: "December",
    value: 12,
  }
];

export const enumAudienceWeekday = [

  {
    label: "Monday",
    value: 1,
  },
  {
    label: "Tuesday",
    value: 2,
  },
  {
    label: "Wednesday",
    value: 3,
  },
  {
    label: "Thursday",
    value: 4,
  },
  {
    label: "Friday",
    value: 5,
  },
  {
    label: "Saturday",
    value: 6,
  }, {
    label: "Sunday",
    value: 7,
  }
]

export const enumAudienceMinutesFunction = () => {
  const enumAudienceMinutes = [];

  for (let i = 0; i <= 59; i++) {
    enumAudienceMinutes.push({
      label: i.toString(),
      value: i
    });
  }
  return enumAudienceMinutes;
}

export const enumAudienceHoursFunction = () => {
  const enumAudienceHours = [];
  for (let i = 0; i <= 23; i++) {
    enumAudienceHours.push({
      label: i.toString(),
      value: i
    })
  }
  return enumAudienceHours;
}

export const enumAudienceDaysFunction = () => {
  const enumAudienceDays = [];
  for (let i = 1; i <= 31; i++) {
    enumAudienceDays.push({
      label: i.toString(),
      value: i
    });
  }
  return enumAudienceDays;
}



export const enumTopUpsStatus = {
  "default": {
    label: 'N/A',
    value: null,
    color: c.cadetGrey.textColor,
    background: c.cadetGrey.background,
  },
  "created": {
    label: 'Created',
    value: 'created',
    color: c.bdazzledBlue.textColor,
    background: c.bdazzledBlue.background,
  },
  "paid": {
    label: 'Paid',
    value: 'paid',
    color: c.bottleGreen.textColor,
    background: c.bottleGreen.background,
  },
  "rejects": {
    label: 'Rejected',
    value: 'rejects',
    color: c.brickRed.textColor,
    background: c.brickRed.background,
  },
}